import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { OnCallRouteName } from '@pages/settings-page/settings-route-names';

export const onCallMenuItemTitle = 'Settings.OnCall';

export const onCallMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.OnCall.Setup',
    routerLink: OnCallRouteName.Setup,
  },
  {
    label: 'Settings.OnCall.StandbyLocation',
    routerLink: OnCallRouteName.StandbyLocation,
    permissions: [RolesAndPermissions.StandbyLocationSettingsRead],
  },
  {
    label: 'Settings.OnCall.Log',
    routerLink: OnCallRouteName.Log,
    permissions: [RolesAndPermissions.StandbyLogSettingsRead],
  },
];
